 // check if any extra render depending on the table        
import { lazy, Suspense } from "react";
import { getTableParam, setTableParam, removeTableParam, getNeedsSelection, buildSelectionInfo, getNodes } from "@/utils/Table.jsx";
const Alert = lazy(() => import('@mui/material/Alert'));

import Button from '@/components/Button';

export const checkRender = (t,api,user,path,table,rows,columns,config,handleButton,sendMessage) => {

	var render = null;

    // if the menu or submenus needs selection on the parent menu
    var needsSelection = getNeedsSelection(path,table);
	if(needsSelection){

        var parent = needsSelection;

        let text;
        var buttonText = null;
        let type;
        var row = null;
        var auto = false;  
        let parentInfo;      

        // if on parent menu
        if(needsSelection === table){
            
            // if there are rows
            if(rows && rows?.length > 0){

                // check if parent item already selected
                parentInfo = getTableParam(user,parent,'selected');

                // if selected, check if it is on the list
                if(parentInfo?.id){

                    var rowsFilter = rows.filter((item) => item.id === parentInfo.id);

                    if(rowsFilter && rowsFilter?.length === 1){
                        row = rowsFilter.pop();
                    }
                }

                // if no row found and there is only one option, autoselect it
                if(!row && rows?.length === 1){                
                    auto = true; 
                    row = rows[0];                
                }

                // if row found, build info
                // even if found on getTableParam, maybe the name has changed
                if(row){

                    parentInfo = buildSelectionInfo(table,row,columns);

                    // if autoselected, show message
                    if(auto){
                        sendMessage(t('actions.autoselected.text',{table:t(table+'.menu.title'),item:parentInfo?.name+parentInfo?.nameappend}));
                    }

                    // save updated info
                    setTableParam(user,parent,'selected',parentInfo);
                }
            }
            else{
                // remove config if there
                removeTableParam(user,parent,'selected');
            }
        }
        else{
            // if not on parent
            // check if parent item already selected
            parentInfo = getTableParam(user,parent,'selected');
        }
           
        // if option selected
        if(parentInfo?.id){
            
            var itemName = '';
            
            if(parentInfo?.name && parentInfo?.name?.length > 0){
                
                itemName = parentInfo?.name;

                if(parentInfo?.nameappend && parentInfo?.nameappend?.length > 0){
                    itemName += parentInfo?.nameappend;
                }
            }            

            text = t('actions.selected.text',{table:t(parent+'.menu.title'),item:itemName});

            // if on parent menu
            /*if(needsSelection === table){
                text = text+'. '+t('actions.selected.subtext');
            }*/

            // if on parent menu do not show button to change if there is only one row
            if(needsSelection !== table || (rows && rows?.length > 1)){
                buttonText = (t('actions.change.button'));
                type = 'success';
            }            
        }
        else{

            // if on parent menu and there are no rows, show message stating it
            // with no button
            buttonText = null;
            if(needsSelection === table && (!rows || rows?.length === 0)){
                text = t('actions.selectnorows.text',{table:t(parent+'.menu.title')});
            }
            else{
                text = t('actions.select.text',{table:t(parent+'.menu.title')});
                buttonText = t('actions.select.button');
            }
            
            type = 'error';
        }
        
        // if root, show button to remove selected if some item selected
        const admin = user?.roles_tags?.includes('root') && parentInfo?.id && needsSelection === table;
        const adminButtonText = admin ? t('actions.remove.button') : null;     
        render = renderAlert(user,api,type,text,buttonText,handleButton,adminButtonText);   
    }

    return render;
}

export const renderAlert = (user,api,type,text,buttonText=null,handleButton = null,adminButtonText = null) => {

    const action =
        <div className='text-end'>
        {
            buttonText &&  
            <div>                     
                <Button    
                    className='app-button'                                                         
                    sx={{}}
                    onClick={() => handleButton(api)}                      
                    text={buttonText}
                />
            </div>
        }
        {
            adminButtonText &&
            <div className='mt-1'>
                <Button                                                             
                    className='app-button'   
                    sx={{marginLeft:1}}
                    onClick={() => handleButton(api,true)}                      
                    text={adminButtonText}
                />
            </div>
        }
        </div>
    ;
                            
    var render = 
            <div className="w-full mb-4"> 
                <div className="w-full">
                    <Suspense>
                        <Alert 
                            sx={{paddingY:1,paddingX:2,display:'flex',alignItems:'center'}}
                            severity={type}
                            icon={false}
                            action={action}
                        >
                            {text}
                        </Alert>
                    </Suspense>
                </div>
            </div>                                        
        ; 

    return render;         
}

// when adding/updating/deleting items, check if new render
export const checkNewRender = (user,t,api,action,router,table,item,columns,sendMessage,setRender,handleTableItemSelected) => {

    if((setRender && handleTableItemSelected) || action === 'delete'){

        const needsSelection = getNeedsSelection(router?.pathname,table);

        // if on parent menu and we need a selection
        if(needsSelection && needsSelection === table){

            // if editing, not adding
            let buttonText;
            let selectionInfo;
            let message;
            if(action === 'edit'){

                selectionInfo = getTableParam(user,needsSelection,'selected');

                if(item?.id && selectionInfo?.id === item.id && selectionInfo?.name !== item?.name){

                    selectionInfo.name = item?.name;
                    setTableParam(user,needsSelection,'selected',selectionInfo);

                    // if on parent menu do not show button to change if there is only one row
                    buttonText = null;       
                    const rows = getNodes(api);
                    if(rows && rows?.length > 1){
                        buttonText = (t('actions.change.button'));                                            
                    }

                    message = t('actions.selected.text',{table:t(needsSelection+'.menu.title'),item:selectionInfo?.name+selectionInfo?.nameappend});//+'. '+t('actions.selected.subtext');

                    // if root, show button to remove selected if some item selected
                    const admin = user?.roles_tags?.includes('root');
                    const adminButtonText = admin ? t('actions.remove.button') : null;   
                    const renderTable = renderAlert(user,api,'success',message,buttonText,handleTableItemSelected,adminButtonText);                
                    setRender(renderTable);                        
                }                
            }
            else{
                // if adding and there were no rows, change message if selection needed
                if(action === 'add'){

                    // if no rows and adding new one, do not show button to change
                    // if there was one row, change to add button
                    const rows = getNodes(api);
                    if(rows && rows?.length <= 2){

                        buttonText = null;

                        // if one row, autoselect it
                        if(rows?.length === 1){
                            selectionInfo = buildSelectionInfo(needsSelection,item,columns);
                            sendMessage(t('actions.autoselected.text',{table:t(needsSelection+'.menu.title'),item:selectionInfo?.name+selectionInfo?.nameappend}));                                            
                            setTableParam(user,needsSelection,'selected',selectionInfo);
                        }
                        else{
                            // if 2 rows, the other one was autoselected
                            selectionInfo = getTableParam(user,needsSelection,'selected');
                            buttonText = (t('actions.change.button'));
                        }
                        
                        message = t('actions.selected.text',{table:t(needsSelection+'.menu.title'),item:selectionInfo?.name+selectionInfo?.nameappend});//+'. '+t('actions.selected.subtext');

                        // if root, show button to remove selected if some item selected
                        const admin = user?.roles_tags?.includes('root');
                        const adminButtonText = admin ? t('actions.remove.button') : null;   
                        const renderTable = renderAlert(user,api,'success',message,buttonText,handleTableItemSelected,adminButtonText);                
                        setRender(renderTable);
                    }
                }
                else{

                    // if deleting
                    if(action === 'delete'){

                        var paramInfo = getTableParam(user,needsSelection,'selected');
                        const deleteIDs = item; // when deleting, item is the array of deleted ids
                        if(paramInfo?.id && deleteIDs.includes(paramInfo?.id)){
                            removeTableParam(user,needsSelection,'selected');
                            paramInfo = null;
                        }

                        if(setRender && handleTableItemSelected){
                            
                            const rows = getNodes(api);
                            var type = 'success';
                            if(!rows || rows?.length === 0){
                                message = t('actions.selectnorows.text',{table:t(needsSelection+'.menu.title')});
                                type = 'error';
                            }
                            else{
                                // if one row and not selected, autoselect
                                if(rows?.length === 1){

                                    const node = rows[0];
                                    const row = node?.data;
                                    if(!paramInfo?.id || paramInfo?.id !== row?.id){
                                        paramInfo = buildSelectionInfo(needsSelection,row,columns);
                                        sendMessage(t('actions.autoselected.text',{table:t(needsSelection+'.menu.title'),item:paramInfo?.name+paramInfo?.nameappend}));                                            
                                        setTableParam(user,needsSelection,'selected',paramInfo);
                                    }
                                }

                                if(paramInfo?.id){     
                                    
                                    message = t('actions.selected.text',{table:t(needsSelection+'.menu.title'),item:paramInfo?.name+paramInfo?.nameappend});                                    
                                    type = 'success';
                                    
                                    if(rows?.length > 1){
                                        buttonText = (t('actions.change.button'));
                                    }
                                }
                                else{
                                    message = t('actions.select.text',{table:t(needsSelection+'.menu.title')});//+'. '+t('actions.select.subtext');
                                    type = 'success';
                                    buttonText = t('actions.select.button');                                    
                                }
                            }

                            // if root, show button to remove selected if some item selected
                            const admin = user?.roles_tags?.includes('root') && paramInfo?.id;
                            const adminButtonText = admin ? t('actions.remove.button') : null;   
                                                            
                            const renderTable = renderAlert(user,api,type,message,buttonText,handleTableItemSelected,adminButtonText);                                
                            setRender(renderTable);
                        }
                    }
                }
            }
        }
    }
}